import WorkerProfileDto from "@/models/Workers/WorkerProfileDto";

export default class CalculatePayRateForQuickBookRequest {
    workerProfile: WorkerProfileDto;
    date: string;
}